import React, { useEffect, useState } from "react";

export default function OfflineBanner() {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);
    const [showBackOnline, setShowBackOnline] = useState(false);

    useEffect(() => {
        const goOffline = () => {
            setIsOffline(true);
            setShowBackOnline(false);
        };

        const goOnline = () => {
            setIsOffline(false);
            setShowBackOnline(true);
            setTimeout(() => setShowBackOnline(false), 3000);
        };

        window.addEventListener("offline", goOffline);
        window.addEventListener("online", goOnline);
        return () => {
            window.removeEventListener("offline", goOffline);
            window.removeEventListener("online", goOnline);
        };
    }, []);

    if (!isOffline && !showBackOnline) return null;

    return (
        <div
            className={`fixed top-0 left-0 right-0 z-[200] flex items-center justify-center gap-2 py-1.5 text-[12px] font-semibold text-white transition-all ${
                isOffline ? "bg-red-500" : "bg-green-500"
            }`}
        >
            {isOffline ? (
                <>
                    <span className="h-2 w-2 rounded-full bg-white opacity-80 animate-pulse" />
                    No internet connection
                </>
            ) : (
                <>
                    <span className="h-2 w-2 rounded-full bg-white" />
                    Back online
                </>
            )}
        </div>
    );
}
